import Placements from '../Placements';
const placementsWithCapping = [
    Placements.PRESCREEN,
    Placements.SLIDE_UP,
];
const getLocalStorageKey = (placement) => {
    return `braze.${placement}.time`;
};
const getLocalStorageEntry = (placement) => {
    return JSON.parse(window.localStorage.getItem(getLocalStorageKey(placement)) || '{}');
};
const setLocalStorageEntry = (entry, placement) => {
    window.localStorage.setItem(getLocalStorageKey(placement), JSON.stringify(entry));
};
const getTimestampBySection = (section, placement) => {
    var _a;
    const entry = getLocalStorageEntry(placement);
    return (_a = entry === null || entry === void 0 ? void 0 : entry[section]) !== null && _a !== void 0 ? _a : 0;
};
const hasFrequencyCapping = (section, placement, ignoreCapping) => {
    if (placementsWithCapping.includes(placement) && !ignoreCapping) {
        const today4am = new Date().setHours(4, 0, 0, 0);
        return getTimestampBySection(section, placement) > today4am;
    }
    return false;
};
const setFrequencyCapping = (section, placement) => {
    if (placementsWithCapping.includes(placement)) {
        const entry = getLocalStorageEntry(placement);
        entry[section] = Date.now();
        setLocalStorageEntry(entry, placement);
    }
};
export { hasFrequencyCapping, setFrequencyCapping, setLocalStorageEntry };
//# sourceMappingURL=frequencyCapping.js.map